module.exports = __webpack_public_path__ + "media/get-started/BoxProduct-mobile-ed185d1e.png";